export default __webpack_public_path__ + "static/media/validasi-manajer-toko.2e87ac21.png";